import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { AppDownload, Footer, Header, RushBuisness } from "../components";

const BuisnessPage = () => {
  return (
    <>
      <Header />
      <Wrapper>
        <div className="individuals__row__wrapper">
          <div className="individuals__row">
            <div className="indi__header_h5">
              <h5>on-demand delivery for businesses</h5>
            </div>
            <div className="indi__header_h1">
              <h1>Reliable deliveries for modern businesses</h1>
            </div>
            <div className="indi__header_p">
              <p>
                Wecanrush enables businesses send and receive important items .
              </p>
            </div>
            <div className="indi__btn">
              <Link
                onClick={() =>
                  window.open("https://app.wecanrush.com/register", "_blank")
                }
              >
                <div className="indi__first_btn">
                  <button>Create a free account</button>
                </div>
              </Link>

              <Link to="/">
                <div className="indi__secend_btn">
                  <button>Get Estimate</button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="svgMain">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#E5EDFC"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
        <RushBuisness />
        <AppDownload />
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  .individuals__row__wrapper {
    background: #e5edfc;
    width: 100% !important;
    padding-bottom: 87px !important;
  }
  .svgMain {
    margin: -40px;
  }
  .individuals__row {
    padding: 0 24px;
    max-width: 1170px;
    margin: auto;
  }
  @media screen and (max-width: 440px) {
    .individuals__row {
      width: 100% !important;
      padding: 0 20px;
    }
    .svgMain {
      margin: 0;
    }
    .section-center {
      width: 100%;
    }

    .indi__header_h5 {
      padding-top: 130px;
      h5 {
        font-size: 12px !important;
      }
    }

    .indi__header_p {
      padding: 0;
      p {
        width: 100% !important;
        font-weight: 500 !important;
        font-family: "Manrope" !important;
        color: #455880 !important;
      }
    }

    .indi__header_h1 h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 72px;
      color: #6300ff;
      width: 100% !important;
      font-size: 36px !important;
      line-height: 50px !important;
    }

    .indi__header_p p {
      font-size: 16px !important;
      line-height: 30px !important;
      width: 100% !important;
    }
    .indi__first_btn button {
      width: 165.71px !important;
      height: 40px !important;
      font-size: 14px !important;
    }
    .indi__secend_btn button {
      font-size: 14px !important;
      width: 140.71px !important;
      height: 40px !important;
    }
    .individuals__row {
      width: 100% !important;
      padding: 0 24px;
      background: #e5edfc;
      width: 100%;
      padding-bottom: 87px !important;
    }
  }

  .individuals {
    max-width: 1170px;
    padding: 0;
    width: 100%;
  }
  svg {
    /* padding-top: -40px; */
  }

  .indi__header_h5 {
    padding-top: 130px;
    h5 {
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 46px;
      text-transform: uppercase;
      color: #455880;
      letter-spacing: 1.5px;
    }
  }

  .indi__header_h1 {
    padding: 0;
    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 72px;
      width: 655px;
      height: 144px;
      color: #6300ff;
    }
  }

  .indi__header_p {
    padding: 0;
    p {
      font-family: "Manrope";
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 38px;
      margin-top: 20px;
      letter-spacing: 0.3px;

      width: 45%;
      font-weight: 500 !important;
      font-family: "Manrope" !important;
      color: #455880 !important;
    }
  }

  .indi__btn {
    display: flex;
    align-items: center;
    margin-top: 107px;
  }
  .indi__first_btn button {
    background: #1d66ff;
    box-shadow: 0px 2px 4px rgba(0, 16, 75, 0.2);
    border-radius: 5px;
    font-family: Manrope;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    width: 232px;
    height: 56px;
    border: none;
    outline: none;
  }

  .indi__secend_btn button {
    background: linear-gradient(
      110.57deg,
      rgba(229, 237, 252, 0.1) -2.17%,
      #e5edfc 99.02%
    );

    font-family: Manrope;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #1d66ff;
    width: 165px;
    height: 56px;
    margin-left: 20px;
    border-radius: 5px;
    border: none;
    outline: none;
    transition: 0.3s;
    letter-spacing: 0.7px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .indi__secend_btn button:hover {
    background: #1d66ff;
    color: #fff;
  }
`;

export default BuisnessPage;
